module.exports = __webpack_public_path__ + "img/q_21_sor.d194bf3a.png";